import { gql } from '@apollo/client';

export const COMPONENT_LIST_SET_DELETE = gql`
    mutation DeleteComponentListSet( $input: DeleteComponentListSetInput! ) {
            deleteComponentListSet(input: $input) {
            affectedRows
        }
    }
`;

export default COMPONENT_LIST_SET_DELETE;
